import * as React from 'react';
import { Modal, ModalHeader, ModalFooter } from '@lightspeed/flame/Modal';
import { Flex } from '@lightspeed/flame/Core';
import { Button } from '@lightspeed/flame/Button';
import SocketClient from 'pages/views/devices/socketClient';
import { STATUS } from 'pages/views/devices/socketClient/types';
import { setCfdModal } from 'pages/views/devices/utils/helper';
import { DeviceConnection } from './DeviceConnection';
import { ConnectionSelector } from './ConnectionSelector';
import { ModalHeaderContent } from './ModalHeaderContent';

interface CfdConnectionModalProps {
  isModalOpen: boolean;
  connectionStatus: typeof STATUS[keyof typeof STATUS];
}

const CfdConnectionModal: React.FC<CfdConnectionModalProps> = ({
  isModalOpen,
  connectionStatus,
}) => {
  const url = SocketClient.getAppUrl();
  const [showDeviceConnection, setShowDeviceConnection] = React.useState(false);
  const onClose = () => setCfdModal(undefined);

  return (
    <Modal isOpen={isModalOpen} onRequestClose={onClose} css={{ width: '600px' }}>
      <ModalHeader css={{ alignItems: 'unset' }}>
        <ModalHeaderContent
          handleClick={() => setShowDeviceConnection(false)}
          showDeviceConnection={showDeviceConnection}
        />
      </ModalHeader>
      {showDeviceConnection || window.isGriffin() ? (
        <DeviceConnection url={url} connectionStatus={connectionStatus} />
      ) : (
        <ConnectionSelector url={url} handleClick={() => setShowDeviceConnection(true)} />
      )}
      <ModalFooter>
        <Flex justifyContent="flex-end">
          <Button onClick={onClose}>Close</Button>
        </Flex>
      </ModalFooter>
    </Modal>
  );
};

export { CfdConnectionModal };
